import React from 'react';
import { Clock } from 'lucide-react';

export interface TimerStyle01Props {
  value?: string;
  options: string[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
  showExpanded?: boolean;
  labels?: Record<string, string>;
}

// Default timer display translations
const DEFAULT_TIMER_LABELS: Record<string, string> = {
  '0': '關閉',
  '1': '1 小時',
  '2': '2 小時',
  '3': '3 小時',
  '4': '4 小時',
  '5': '5 小時',
  '6': '6 小時',
  '7': '7 小時',
  '8': '8 小時',
  '9': '9 小時',
  '10': '10 小時',
  '11': '11 小時',
  '12': '12 小時'
};

/**
 * Timer Style 01 - Grid Layout
 * Command: SetModes (Timer)
 * Grid of timer options with expandable view
 */
export const Style01_Grid: React.FC<TimerStyle01Props> = ({
  value,
  options,
  disabled = false,
  loading = false,
  onChange,
  label = '預約定時',
  showExpanded = false,
  labels = DEFAULT_TIMER_LABELS
}) => {
  const [expanded, setExpanded] = React.useState(showExpanded);
  
  const getTimerLabel = (timer: string): string => {
    return labels[timer] || `${timer} 小時`;
  };

  // Show first 6 options or all if expanded
  const visibleOptions = expanded ? options : options.slice(0, 6);
  const hasMore = options.length > 6;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 text-purple-400" />
        <span className="text-sm font-medium text-slate-300">{label}</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {visibleOptions.map((timer) => {
          const isSelected = value === timer;
          return (
            <button
              key={timer}
              onClick={() => onChange(timer)}
              disabled={disabled || loading}
              className={`px-3 py-2 rounded-lg text-xs font-medium transition-all ${
                isSelected
                  ? 'bg-purple-500 text-white shadow-lg shadow-purple-500/30'
                  : 'bg-slate-700/50 text-slate-300 hover:bg-slate-600'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading && isSelected ? '...' : getTimerLabel(timer)}
            </button>
          );
        })}
      </div>
      {hasMore && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-xs text-purple-400 hover:text-purple-300 transition-colors"
        >
          {expanded ? '收起更多選項 ↑' : '展開更多選項 ↓'}
        </button>
      )}
    </div>
  );
};

export default Style01_Grid;
